export default __webpack_public_path__ + "static/media/370.5456e0e7.jpg";